import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterModel } from 'src/app/models/master/master-model';
import { AddressType } from 'src/app/models/type/address.type.enum';
import { Tabs } from 'src/app/models/ui/tabs';
import { environment as env } from 'src/environments/environment';
import { PhoneGA } from '../models/inputs/phoneGA-model';
import { constants, factory } from '../config/constants';

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  constructor(private http: HttpClient) { }

  getAddressType(): Observable<Array<DropdownModel>> {
    return new Observable(observer => {
      observer.next([
        { label: 'address.type.registered', value: AddressType.registered },
        { label: 'address.type.present', value: AddressType.present },
        { label: 'address.type.office', value: AddressType.office }
      ]);
    });
  }

  getProvinces(): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getProvince`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getDistricts(provinceId?: any): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getDistrict`,
      { params: { provinceId: provinceId } }).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getSubDistricts(districtId?: any): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getSubDistrict`,
      { params: { districtId: districtId } }).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getProductPanel(): Observable<Array<Tabs>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getProductPanel`).pipe(
      map((data) => {
        return data.map(item => {
          return { id: item.id, name: item.name, keyword: item.code, groupMap: item.desc1 };
        });
      })
    );
  }

  getModeOfPayment(): Observable<Array<MasterModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getModeOfPayment`);
  }

  getTitleNames(): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getTitleName`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getOccupation(excludeCode:boolean=false): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getOccupation`).pipe(
      map((data) => {
        return data.map(item => {
            if(!factory.occYouth && item.code == constants.occCodeYouth)
                {
                    factory.occYouth = {"id": item.id, "code": item.code}
                    // console.log(factory.occYouth);
                }
            return { value: item.id, label: item.name, jobClass:item.jobClass, data: item };
          // return { value: item.id, label: (!excludeCode?(item.code + (item.code ? ' - ' : '')):"") + item.name, jobClass:item.jobClass, data: item };
        });
      })
    );
  }
  getOccupationForSingle(excludeCode:boolean=false): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getOccupationSingle`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
          // return { value: item.id, label: (!excludeCode?(item.code + (item.code ? ' - ' : '')):"") + item.name, data: item };
        });
      })
    );
  }

  getOccupationQQ(): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getOccupationQQ`).pipe(
      map((data) => {
        return data.map((item,index) => {
          return { value: item.id, label: (index + 1).toString(), data: item };
        });
      })
    );
  }

  getOccupationById(occupationId): Observable<any> {
    const url = `${env.apiEndpoint}/master/getOccupationById`;
    return this.http.get<any>(url, {
      params: {
        occupationId: '' + occupationId
      }
    }).pipe(map(data => {
      return data;
    }));
  }


  getRelation(): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/relation`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getNationality(): Observable<Array<DropdownModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getNationality`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getMaritalStatus(): Observable<Array<MasterModel>> {
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getMaritalStatus`);
  }

  getGANumber():Observable<PhoneGA>{
    const pNumber = `${ env.apiEndpoint }/master/getGANumber` ;
    return this.http.get<any>(pNumber);
  }

  getFamilyType():Observable<Array<DropdownModel>>{
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/familyType`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }

  getTaxRate():Observable<Array<DropdownModel>>{
    return this.http.get<Array<MasterModel>>(`${env.apiEndpoint}/master/getTexRate`).pipe(
      map((data) => {
        return data.map(item => {
          return { value: item.id, label: item.name, data: item };
        });
      })
    );
  }
}
